;(function ( $, Konva) {
    let TB_CanvasAdjust = function ($container) {
        let self = this;
        self.$container = $container;
        self.canvas = {
            full:       $container.find('.canvas-full')[0],
            clipped:    $container.find('.canvas-clipped')[0],

        };
        self.konva = {
            full:         new Konva.Stage({
                width: 640,
                height: 480,
                container: self.canvas.full
            }),
            clipped:       new Konva.Stage({
                width: 270,
                height: 380,
                container: self.canvas.clipped
            }),
            points: {
                p1: undefined,
                p2: undefined,
                el: undefined,
                er: undefined,
                w: TryonImage_config.fix_width,
                h: TryonImage_config.fix_height
            },
            controlLayer: new Konva.Layer(),
            fullImageLayer: new Konva.Layer(),
            clipLayer: new Konva.Layer(),
            clipImage: undefined,

        };
        self.transform = {
            x: 0,
            y:0,
            scale: 0,
            angel: 0
        };
        self.konva.clipLayer.setAttrs({
            x:self.konva.clipped.width()/2,
            y:self.konva.clipped.height()/2 - 15
        });
        self.konva.full.add(self.konva.fullImageLayer,self.konva.controlLayer);
        self.konva.clipped.add(self.konva.clipLayer);
        $container.on('change','input.file-uploader',{app: self},self.onFileChange);
        $container.on('click','.save',{app: self},self.saveClip);
        $container.on('imageUploaded',{app:self},self.drawImage);
        $container.on('imageUploaded',{app:self},self.constructController);
        $container.on('pointerMove',  {app:self},self.pointerMove);
        $container.on('adjustImage',  {app:self},self.adjustImage);

        $container.on('change','select.tryon-eye-select',function(){
            if ($(this).hasClass('tryon-left'))     self.konva.points.el = $(this).val();
            if ($(this).hasClass('tryon-right'))    self.konva.points.er = $(this).val();

            if (self.konva.clipImage !== undefined)
                $container.trigger('pointerMove');
        });
        $container.find('select.tryon-eye-select').trigger('change');
        $(document).on('opening opened', '.remodal-adjust-canvas', function () {
            if (self.image === undefined) {
                location.href = '#select';
            }
        });

    };
    /**
     *
     * @param event
     */
    TB_CanvasAdjust.prototype.saveClip = function(event) {
        let $app    = event.data.app,
            canvas  = $app.konva.clipLayer.getContext().canvas._canvas,
            src     = canvas.toDataURL("image/jpeg", 100),
            key     = 'tbCanvasStorage',
            current = 'tbCanvasCurrent',
            storage = {};
        try {
            storage = JSON.parse(localStorage.getItem('tbCanvasStorage'));
        } catch (e) {}

        if (storage === null) storage = {};


        if (! Object.values(storage).includes(src) ) {
            storage[Date.now()] = src;
        }
        /**
         * Reverse
         * @type {{}}
         */
        storage =  Object.keys(storage).sort().reverse().reduce((a, c) => (a[c] = storage[c], a), {});
        localStorage.setItem(key,JSON.stringify(storage));
        Cookies.set('tbTryon',{
           type: 'local',
           id: Object.keys(storage)[0]
        });
        $(document).trigger('tryonSaveClip');
    };

    let drawPreparedImage =  function() {
        var left_eye_value = parseFloat(document.getElementById("eye-left").value) - 3.5
            , right_eye_value = parseFloat(document.getElementById("eye-right").value) - 3.5
            , c = document.getElementById("tryon_point0")
            , d = document.getElementById("tryon_point1");
        c.offsetLeft > d.offsetLeft && (d = document.getElementById("tryon_point0"),
            c = document.getElementById("tryon_point1"));
        var e = c.offsetLeft + 27;
        c = c.offsetTop + 27;
        var k = d.offsetLeft + 27;
        d = d.offsetTop + 27;
        var f = k - e
            , g = d - c
            , h = 0 !== f ? Math.atan(g / f) : 0 < g ? 90 : -90;
        h = 0 !== h ? -h : 0;
        distance = Math.pow(f * f + g * g, .5);
        picFull = $$(".adjust-box .full").first();
        ajustedCanvas = document.createElement("canvas");
        ajustedCanvas.width = 640;
        ajustedCanvas.height = 480;
        ctxA = ajustedCanvas.getContext("2d");
        fullCanvas = document.createElement("canvas");
        fullCanvas.width = 3200;
        fullCanvas.height = 2400;
        ctxF = fullCanvas.getContext("2d");
        ctxA.save();
        ctxA.setTransform(1, 0, 0, 1, 0, 0);
        ctxA.fillStyle = "#FFF";
        ctxA.fillRect(0, 0, ajustedCanvas.width, ajustedCanvas.height);
        ctxA.restore();
        ctxA.drawImage(picFull, 320 - k / 2 - e / 2, 240 - d / 2 - c / 2);
        ctxF.save();
        ctxF.setTransform(1, 0, 0, 1, 0, 0);
        ctxF.fillStyle = "#FFF";
        ctxF.fillRect(0, 0, fullCanvas.width, fullCanvas.height);
        ctxF.restore();
        ctxF.save();
        ctxF.translate(fullCanvas.width / 2, fullCanvas.height / 2);
        ctxF.rotate(h);
        ctxF.translate(-fullCanvas.width / 2, -fullCanvas.height / 2);
        ctxF.drawImage(ajustedCanvas, (fullCanvas.width - 640) / 2, (fullCanvas.height - 480) / 2);
        ctxF.restore();
        scale = 90 / distance * ((left_eye_value + right_eye_value) / 70);
        clippedCanvas = $$("canvas.clipped").first();
        ctx = clippedCanvas.getContext("2d");
        ctx.fillStyle = "#FFF";
        ctx.fillRect(0, 0, clippedCanvas.width, clippedCanvas.height);
        width = Math.round(270 / scale);
        sideX = Math.round((fullCanvas.width - width) / 2) + 5;
        height = Math.round(380 / scale);
        sideY = Math.round((fullCanvas.height + 5 - height) / 2);
        posX = (left_eye_value - right_eye_value) / 2 + 2;
        posY = -10;
        ctx.drawImage(fullCanvas, sideX, sideY, width, height, posX, posY, 270, 380)
    }
    /**
     *
     * @param event
     */

    TB_CanvasAdjust.prototype.adjustImage = function(event) {
        let $app    = event.data.app,
            bgScale = 5;

        $app.konva.clipLayer.destroyChildren();
        $app.konva.clipImage = new Konva.Image({
            x: 0,
            y: 0,
            image: $app.konva.fullImageLayer.getCanvas()._canvas,
            width:$app.konva.fullImageLayer.width(),
            height:$app.konva.fullImageLayer.height(),

        });

        let bg = new Konva.Rect({
            width: $app.konva.fullImageLayer.width() * bgScale,
            height: $app.konva.fullImageLayer.height() * bgScale,
            fill: '#ffffff',
            x: -$app.konva.fullImageLayer.width() * bgScale / 2,
            y: -$app.konva.fullImageLayer.height() * bgScale / 2
        });
        $app.konva.clipLayer.add(bg);
        $app.konva.clipLayer.add($app.konva.clipImage);
        $app.konva.clipImage.scale({
            x:$app.transform.scale,
            y:$app.transform.scale
        });
        $app.konva.clipImage.position({
            x:-$app.transform.x * $app.transform.scale,
            y:-$app.transform.y * $app.transform.scale
        });

        $app.konva.clipLayer.rotate($app.transform.angel - $app.konva.clipLayer.getRotation());
        $app.konva.clipLayer.batchDraw();
    };
    /**
     *
     * @param event
     */
    TB_CanvasAdjust.prototype.pointerMove = function(event) {

        let $app    = event.data.app,
            p1      = {
                x: $app.konva.points.p1.x() + ($app.konva.points.w / 2),
                y: $app.konva.points.p1.y() + ($app.konva.points.h / 2),
            },
            p2      = {
                x: $app.konva.points.p2.x() + ($app.konva.points.w / 2),
                y: $app.konva.points.p2.y() + ($app.konva.points.h / 2),
            };

        if (p1.x > p2.x) {
            let _p = p1;
            p1 = p2;
            p2 = _p;
        }


        let length = p2.x - p1.x,
            height = p2.y - p1.y,
            angel = 0 !== length ? Math.atan(height / length) : 0 < height ? 90 * Math.PI / 180 : -90 * Math.PI / 180;

            angel  = 0 !== angel ? -angel : 0;

            let left = $app.konva.points.el - 3.5,
                right = $app.konva.points.er - 3.5;

       // console.log(left,right);
        let distance = Math.pow(length * length + height * height, .5);
        //console.log(distance);
        //let scale = 90 / distance * ((left_eye_value + right_eye_value) / 70);
        //$app.transform.scale = 90/Math.pow(length * length + height * height, .5);
        $app.transform.scale = 90/distance * ( (left + right)/ 70 );
        //$app.transform.scale = ( left + right )/distance;
        $app.transform.angel = angel * 180 / Math.PI;
        $app.transform.x = Math.min(p1.x,p2.x) + (Math.max(p1.x,p2.x) - Math.min(p1.x,p2.x))/2;
        //$app.transform.x = $app.transform.x + ( (left - right)/2 + 2 );
        $app.transform.y = Math.min(p1.y,p2.y) + (Math.max(p1.y,p2.y) - Math.min(p1.y,p2.y))/2;
        //$app.transform.y = $app.transform.y + 10;

        console.log($app.transform);


        $app.$container.trigger('adjustImage');
    };
    /**
     *
     * @param event
     */
    TB_CanvasAdjust.prototype.drawImage = function(event){
        let $app    = event.data.app,
            width   = $app.image.width,
            height  = $app.image.height,
            scale   = Math.min( $app.konva.full.width() / width, $app.konva.full.height() / height);


        width  *= scale;
        height *= scale;


        let dx = ( $app.konva.full.width()  - width ) /2,
            dy = ( $app.konva.full.height() - height) /2;

        let K_Image = new Konva.Image({
            x: dx,
            y: dy,
            image: $app.image,
            width: width,
            height: height
        });



        $app.konva.fullImageLayer.destroyChildren();
        $app.konva.fullImageLayer.add(K_Image);
        $app.konva.fullImageLayer.batchDraw();
    };
    /**
     * Controller
     * @param event
     */
    TB_CanvasAdjust.prototype.constructController = function(event) {
        let $app = event.data.app;
        if ($app.konva.points.p1 !== undefined || $app.konva.points.p2 !== undefined)
            return;


        Konva.Image.fromURL(TryonImage_config.fix_url,function(image){
            $app.konva.points.p1 = new Konva.Image({
                image: image.attrs.image,
                width: $app.konva.points.w,
                height: $app.konva.points.h,
                draggable: true,
                x: $app.konva.full.width() * .4,
                y: $app.konva.full.height() * .3,
                dragBoundFunc: function(pos) {
                    if (pos.x <= 0 )
                        pos.x = 0;
                    if (pos.x >= $app.konva.full.width() - $app.konva.points.w)
                        pos.x = $app.konva.full.width() - $app.konva.points.w;

                    if (pos.y <= 0 )
                        pos.y = 0;
                    if (pos.y >= $app.konva.full.height() - $app.konva.points.h)
                        pos.y = $app.konva.full.height() - $app.konva.points.h;
                    $app.$container.trigger('pointerMove');
                    return {
                        x: pos.x,
                        y: pos.y
                    };
                }
            });

            $app.konva.points.p2 = $app.konva.points.p1.clone();
            $app.konva.points.p2.setAttrs({
                x:$app.konva.full.width() * .6
            });
            $app.konva.controlLayer.add($app.konva.points.p1,$app.konva.points.p2);
            $app.$container.trigger('pointerMove');
            $app.konva.controlLayer.batchDraw();
        });
    };
    /**
     *
     * @param event
     */
    TB_CanvasAdjust.prototype.onFileChange = function(event){
       // $('[data-remodal-id="upload"]').remodal().open();
        let fileReader = new FileReader();
        let $app = event.data.app;

        fileReader.onload = function(frEvent) {
            let img = new Image();
            img.onload = function(){
                $app.image = this;
                $app.$container.trigger('imageUploaded');
                location.href = '#upload';
            };
            img.src = frEvent.target.result;
        };
        fileReader.readAsDataURL(event.target.files[0]);
    };




    let TB_Rotate360 = function(container) {
        let self = this;
        self.$container = $(container);
        self.$list      = self.$container.find('.tb-rotator__list');
        self.$items     = self.$list.find('li');

        self.reverse    = self.$container.data('reverse') || false;
        self.axisStep   = self.$container.data('step') || 15;
        self.playDelay  = self.$container.data('delay') || 100;

        self.drag       = false;
        self.axisStart  = 0;
        self.axisStop   = 0;
        self.playing    = false;



        self.playInterval = setInterval(function(){
            if (self.playing)
                self.$container.trigger('goNext');
        },self.playDelay);


        /**
         * Заменяем изображения
         */
        self.$items.find('img').each(function(){
            let tb_src = $(this).attr('data-tb_src');
            if (tb_src !== undefined) {
                $(this).attr('src',tb_src);
            }
        });
        self.$list.imagesLoaded()
            .always( function( instance ) {
                self.playing = self.$container.data('play') || false;
                self.$list.removeClass('is-loading');
            })
            .progress( function( instance, image ) {
            });

        self.$container.on('goNext',    {app: self},self.goNext);
        self.$container.on('goBack',    {app: self},self.goBack);
        self.$container.on('goTo',      {app: self},self.goTo);
        self.$container.on('playGo',    {app: self},self.playGo);
        self.$container.on('playStop',  {app: self},self.playStop);

        self.$list.on('mousedown touchstart mouseleave mouseup touchend mousemove touchmove',{app: self},self.move);

        if (!self.playing) {
            self.$container.trigger('playStart');
        }
    };

    /**
     *
     * @param event
     */
    TB_Rotate360.prototype.playGo = function (event) {
        let $app    = event.data.app;
        $app.playing = true;
        $app.$container.addClass('list-playing');
    };
    /**
     *
     * @param event
     */
    TB_Rotate360.prototype.playStop = function (event) {
        let $app    = event.data.app;
        $app.playing = false;
        $app.$container.removeClass('list-playing');
    };
    /**
     *
     * @param event
     */
    TB_Rotate360.prototype.goNext = function (event) {
        let $app    = event.data.app,
            index = $app.$list.find('li.active').index() + 1;

        index++;
        if (index > $app.$items.length) {
            index = 1;
        }
        $app.$container.trigger('goTo', index);
    };
    /**
     *
     * @param event
     */
    TB_Rotate360.prototype.goBack = function (event) {
        let $app    = event.data.app,
            index =$app.$list.find('li.active').index() + 1;

        index--;
        if (index <1) {
            index = $app.$items.length;
        }
        $app.$container.trigger('goTo', index);
    };
    /**
     *
     * @param event
     * @param n
     */
    TB_Rotate360.prototype.goTo = function (event,n) {
        let $app    = event.data.app;
        $app.$items.removeClass('active').eq(n-1).addClass('active');

    };
    /**
     *
     * @param event
     */
    TB_Rotate360.prototype.move = function (event) {
        event.preventDefault();
        let $app    = event.data.app;

        switch (event.type) {
            case 'mouseup':
            case 'mouseleave':
            case 'touchend':
                $app.$list.removeClass('drag-start');
                $('body').removeClass('list--drag');
                $app.drag = false;
                break;
            case 'touchstart':
            case 'mousedown':
                $('body').addClass('list--drag');
                $app.$list.addClass('drag-start');
                $app.$container.trigger('playStop');
                $app.drag = true;
            break;
        }
        switch (event.type) {
            case 'touchstart':
                $app.axisStart = event.originalEvent.touches[0].pageX;
                $app.axisStop = $app.axisStart;
                break;
            case 'touchmove':
                $app.axisStop = event.originalEvent.touches[0].pageX;
                break;
            case 'mousedown':
                $app.axisStart = event.pageX;
                $app.axisStop = $app.axisStart;
                break;
            case 'mousemove':
                $app.axisStop = event.pageX;
                break;
        }
        if ( ! $app.drag) return;


        if ($app.axisStop > $app.axisStart + $app.axisStep ) {
            $app.axisStart = $app.axisStop;
            if ($app.reverse) {
                $app.$container.trigger('goBack');
                return;
            }
            $app.$container.trigger('goNext');
        } else if ($app.axisStop < $app.axisStart - $app.axisStep) {
            $app.axisStart = $app.axisStop;
            if ($app.reverse) {
                $app.$container.trigger('goNext');
                return;
            }
            $app.$container.trigger('goBack');
        }
    };
    $.fn.rotate360 = function(){

        this.each(function(){
            new TB_Rotate360(this);
        });

        return this;
    };
    $.fn.tb_tryon_image = function () {
        new TB_CanvasAdjust(this);
        return this;
    };

    $.fn.tb_tryon_current = function() {
        let cookie = JSON.parse(Cookies.get('tbTryon'));
        if (cookie !== undefined)
            return cookie;

        return  false;
    };

    /**
     * Simple scripts
     */
    $(function() {
        $( '.tryon-adjust' ).each( function() {
            $( this ).tb_tryon_image();
        });
        $('.tb-rotator-single').rotate360();

        $(document).on('opened', '.remodal-zoom-rotator', function () {
            console.log('Modal is opening');
            $('.tb-rotator-full').rotate360();
        });
        /**
         * Tabs
         */
        $(document).on('click','[data-tba_category_target]',function(){
            $('[data-tba_category_target]').removeClass('active');
            $(this).addClass('active');

            $('.tb-adjust-selector__list-images__item').removeClass('in-view');
            $('.tb-adjust-selector__list-images__item.tb-adjust-list__' + $(this).data('tba_category_target')).addClass('in-view');
        });

        /**
         *
         */
        $( window ).on( 'storage onstorage', function ( e ) {
            //TODO вызвать функцию перерисовки текущего
           $(document).trigger('tryonUpdateImage');
        });
        $(document).on('tryonSaveClip',function(){
            $('[data-remodal-action="close"]').trigger('click');
            $(document).trigger('tryonDrawCanvas');
        });
        $(document).on('tryonDrawCanvas',function(){
            console.log('tryonDrawCanvas');
            let canvasList = {};
            try {
                canvasList = JSON.parse(localStorage.getItem('tbCanvasStorage'));
                canvasList = Object.keys(canvasList).sort().reduce((a, c) => (a[c] = canvasList[c], a), {});
            } catch (e) {

            }

            let list = $('.tb-adjust-selector__list-images')

            list.find('.tb-adjust-list__local').remove();

            console.log(canvasList);
            $.each(canvasList,function(id,src) {
                let item = $('.tb-adjust-selector__list-images__item.tb-adjust-list__media')
                    .first()
                    .clone()
                    .addClass('tb-adjust-list__female tb-adjust-list__male tb-adjust-list__custom tb-adjust-list__local in-view')
                    .removeClass('tb-adjust-list__media');
                item.find('.tb-adjust-selector__list-button')
                    .attr('data-media_id',id)
                    .attr('data-media_type','local');
                item

                    .find('img.tryon-img')
                    .attr('src',src)
                    .after($('<span class="custom-del"><svg class="icon-svg"><use xlink:href="' +TryonImage_config.svg+ '#trash"></use></svg></span>'))

                list.prepend(item);
            });
            $(document).trigger('tryonSelectImg');
        });
        /**
         * События выбора "изображения"
         */
        $(document).on('click','.tb-adjust-selector__list-button',function(){
            $(document).trigger('tryonSelectImg',[$(this).attr('data-media_type'),$(this).attr('data-media_id'),$(this)]);
        });

        $(document).on('click','.tb-adjust-selector__list-button .custom-del',function(e){
           e.stopPropagation();
           let parent = $(this).parent();
           let type = parent.attr('data-media_type'),
               id   = parent.attr('data-media_id');

           if (type === 'local') {
               let storage = JSON.parse(localStorage.getItem('tbCanvasStorage'));
               console.log(storage);
               delete(storage[id]);
               localStorage.setItem('tbCanvasStorage',JSON.stringify(storage));
               $(document).trigger('tryonDrawCanvas');
           }
           console.log(parent);
        });

        $(document).on('tryonSelectImg',function(e,type,id){
            console.log('tryonSelectImg')
            if (type === undefined || id === undefined) {
                let cook = Cookies.get('tbTryon');
                if (cook !== undefined) {
                    cook = JSON.parse(cook);
                    type = cook.type;
                    id   = cook.id;
                } else {
                    type = TryonImage_config.type;
                    id   = TryonImage_config.id;
                }
            }

            let button = $('.tb-adjust-selector__list-button[data-media_type="' + type + '"][data-media_id="' + id + '"]');
            if (!button.length) {
                button = $('.tb-adjust-selector__list-button[data-media_type="' + TryonImage_config.type + '"][data-media_id="' + TryonImage_config.id + '"]');
                type = TryonImage_config.type;
                id = TryonImage_config.id;
            }

                let img = button.find('img').attr('src');
                $('.tb-adjust-selector__list-button').removeClass('user-selected');
                button.addClass('user-selected');
                $('.tb-adjust-view__face img').attr('src',img);
                Cookies.set('tbTryon',{
                    type: type,
                    id: id
                },{ expires: 30 } );


            $('[data-remodal-action="close"]').trigger('click');

        });


        let $drag = $('.tb-adjust-view__frame img');
        $('.tb-adjust-view__frame').on('mousedown',function(e){
            e.preventDefault(); // disable selection
            let $wrap = $(this),
                $img = $wrap.find('img').addClass('draggable'),
                drg_h = $img.outerHeight(),
                drg_w = $img.outerWidth(),
                pos_y = $img.offset().top + drg_h - e.pageY,
                pos_x = $img.offset().left + drg_w - e.pageX;


            $(this).on('mousemove',function(e){
                $wrap.find('.draggable').offset({
                    top:e.pageY + pos_y - drg_h,
                    left:e.pageX + pos_x - drg_w
                });
            });
            $(this).on('mouseup',function(e){
                $img.removeClass('draggable');
            });
        });
        /**
         * Init
         */
        $(document).trigger('tryonDrawCanvas')
    });



})( jQuery, Konva );